import React from "react";

export default function ShippingPolicy() {
  return (
    <div style={{ padding: "20px", maxWidth: "900px", margin: "auto" }}>
      <h1>Shipping Policy</h1>
      <p>Last updated: 05 December 2025</p>

      <h2>Delivery Time</h2>
      <p>
        Orders are processed within 1–2 business days. Delivery usually takes
        3–7 days depending on your location and courier speed.
      </p>

      <h2>Shipping Charges</h2>
      <p>
        Shipping charges are displayed at checkout. Free delivery may be
        available on selected orders.
      </p>

      <h2>Tracking</h2>
      <p>
        After dispatch, customers will receive a tracking ID via SMS or email.
      </p>

      <h2>Contact</h2>
      <p>
        Queries related to shipping? Contact:<br />
        📞 8770561028 <br />
        📧 support@kwicth.in
      </p>
    </div>
  );
}
